import React from 'react';
import { useSelector } from 'react-redux';
import ProductCard from '../ProductCards/ProductCard';
import ListProductCard from '../ProductCards/ListProductCard';
import clsx from 'clsx';
import { ProductListingType } from '../../constants';
import useIsMobile from '../../Hooks/useIsMobile';
import { translate } from '../../Services/translation';
import useIsAuthenticated from '../../Hooks/useIsAuthenticated';
import ListingPagination from './../ListingPagination';
import { dataLayerViewItemList } from '../../Services/Gtm.service';

const ProductListing = () => {
  const isMobile = useIsMobile();
  const isAuthenticated = useIsAuthenticated();
  const {
    products,
    productListingType,
    pagination,
    defaultProductListingType,
  } = useSelector((state) => state.productListing);

  const gtmEcommerceItems = products.map(p => p.gtmEcommerceItem);
  if (gtmEcommerceItems) {
    dataLayerViewItemList(gtmEcommerceItems);
  }

  return (
    <>
      <div
        className={clsx(
          'product-listing',
          ((productListingType === ProductListingType.List && !isMobile) ||
            (isMobile &&
              defaultProductListingType === ProductListingType.List)) &&
            'product-listing--list',
          ((productListingType === ProductListingType.Grid && !isMobile) ||
            (isMobile &&
              defaultProductListingType === ProductListingType.Grid)) &&
            'product-listing--grid'
        )}
      >
        {productListingType == ProductListingType.List && !isMobile && (
          <div
            className={clsx(
              'product-listing__table-header',
              !isAuthenticated && 'product-listing__table-header--not-auth'
            )}
          >
            <div className="product-listing__table-header-left">
              <div className="product-listing__table-header-col product-listing__table-header-col--desc">
                {translate('product.part-description')}
              </div>
              <div className="product-listing__table-header-col product-listing__table-header-col--artno">
                {translate('product.artno')}
              </div>
              <div className="product-listing__table-header-col product-listing__table-header-col--stockstatus">
                {translate('product.stockstatus')}
              </div>
              <div className="product-listing__table-header-col product-listing__table-header-col--units">
                {translate('product.units')}
              </div>
            </div>
            <div className="product-listing__table-header-right">
              <div className="product-listing__table-header-col product-listing__table-header-col--price">
                {translate('product.price')}
              </div>
              <div className="product-listing__table-header-col product-listing__table-header-col--quantity">
                {translate('product.quantity')}
              </div>
            </div>
          </div>
        )}
        {!!products.length &&
          ((isMobile &&
            defaultProductListingType === ProductListingType.List) ||
            (productListingType === ProductListingType.List && !isMobile)) &&
          products.map((product) => (
            <ListProductCard
              {...product}
              isAuthenticated={isAuthenticated}
              key={product.id}
            />
          ))}
        {!!products.length &&
          ((isMobile &&
            defaultProductListingType === ProductListingType.Grid) ||
            (productListingType === ProductListingType.Grid && !isMobile)) &&
          products.map((product) => (
            <ProductCard
              {...product}
              isAuthenticated={isAuthenticated}
              key={product.id}
            />
          ))}
      </div>
      <div className="product-listing__table-footer">
        <ListingPagination {...pagination} />
      </div>
    </>
  );
};

export default ProductListing;
